import styled from 'styled-components';
import { CheckboxInput } from '../inputs/CheckboxInput.js';
import { CHECKBOX_SIZE_REM } from '../inputs/InputCommon.js';
import { CheckboxField } from './CheckboxField.js';

/**
 * Local constants
 */ const CHECKBOX_SECONDARY_SIZE_REM = CHECKBOX_SIZE_REM - 0.25;
/**
 * Styled Components
 */ const CheckboxSecondaryCheckbox = styled(CheckboxField)`
  & [${CheckboxInput.dataId}-custom-input] {
    border-radius: 0.25rem;
    height: ${CHECKBOX_SECONDARY_SIZE_REM}rem;
    width: ${CHECKBOX_SECONDARY_SIZE_REM}rem;

    &:after {
      top: 0.05rem;
      left: 0.3125rem;
    }
  }

  & [${CheckboxInput.dataId}-label] {
    font-weight: 300;
    font-size: 0.75rem;
    /* a break in the system - TODO: fix this so it conforms to general spacing rules */
    margin-left: -0.25rem;
  }
`;
/**
 * Checkbox Secondary Input with Formik Field bindings.
 *
 * @example
 * <CheckboxSecondaryField name="chekkkers" />
 */ const CheckboxSecondaryField = CheckboxSecondaryCheckbox;
CheckboxSecondaryField.dataId = "data-hpy-web-checkbox-secondary-field";
CheckboxSecondaryField.displayName = "CheckboxSecondaryField";

export { CheckboxSecondaryField };
